var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNatureventyrRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_186)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.0748,
    cy: 10.5,
    r: 10.5,
    fill: "#746D51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7384 7.87864L16.6337 5.28921C16.7261 5.02136 16.479 4.76354 16.2223 4.85997L13.7586 5.78743C13.688 5.82092 13.602 5.81355 13.5365 5.76065L11.4526 4.07181V4.07114C11.2363 3.89703 10.9264 4.0631 10.9354 4.34636L11.0201 7.09796C11.022 7.17229 10.9893 7.24528 10.9264 7.29015L8.74375 8.83634C8.51784 8.99639 8.57303 9.35598 8.83488 9.43501L11.3686 10.2011C11.4366 10.2218 11.4937 10.2774 11.5149 10.3538L12.2491 12.9975C12.3248 13.2701 12.6695 13.329 12.8229 13.0926L14.2989 10.8239C14.3381 10.7576 14.4093 10.7141 14.4889 10.7168L17.1259 10.8052C17.3968 10.8146 17.5578 10.4918 17.3897 10.2655L15.7705 8.09175L15.7712 8.09108C15.7275 8.03349 15.7127 7.95364 15.7384 7.87864ZM10.2508 10.3302L11.1351 10.5974L11.3912 11.5202L6.85834 16.6665C6.84679 16.6792 6.83716 16.6899 6.82946 16.6986L6.82882 16.6979C6.63052 16.9049 6.36803 17.0026 6.10425 16.9999C5.10245 16.9906 4.64424 15.7089 5.31938 15.0601L10.2508 10.3302Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.574829)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatureventyrRoute);
export default __webpack_public_path__ + "static/media/NatureventyrRoute.5b7728726aaeb021be5afc2862e20f4c.svg";
export { ForwardRef as ReactComponent };